import React from 'react'
import { App, Button } from 'antd'
import { useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import { rubricRefinementSelectors } from '../../../../../../../store/selectors/rubricRefinement.selectors'
import {
    useStartOverRefinementMutation,
    useStartRefinementMutation,
} from '../../../../../../../store/apis/rubric-refinement.api'
import { ExclamationCircleOutlined, RetweetOutlined } from '@ant-design/icons'

const StartOverButton = props => {
    const { modal } = App.useApp()
    const refinementProcess = useSelector(rubricRefinementSelectors.refinementProcess)
    const refinementProgress = useSelector(rubricRefinementSelectors.refinementProgress)
    const [startOverRefinement, { isLoading: isStartingOverRefinement }] = useStartOverRefinementMutation()
    const [startRefinement] = useStartRefinementMutation()

    const { token, layerId: questionRubricId } = useParams()

    const handleStartOver = async () => {
        modal.confirm({
            title: 'Are you sure you want to start over?',
            icon: <ExclamationCircleOutlined />,
            content: 'This will reset the refinement process and start over from the beginning.',
            okText: 'Start Over',
            okType: 'danger',
            onOk: async () => {
                if (refinementProcess?.id) {
                    try {
                        await startOverRefinement({ id: refinementProcess.id, token }).unwrap()
                        await startRefinement({ questionRubricId, token }).unwrap()
                    } catch (error) {
                        console.error('Error starting over:', error)
                    }
                }
            },
        })
    }

    const hasReviewedItems = refinementProgress?.itemsReviewed > 0

    return (
        <Button
            onClick={handleStartOver}
            loading={isStartingOverRefinement}
            type='text'
            danger
            {...props}
            icon={<RetweetOutlined />}
            disabled={!hasReviewedItems}
        >
            Start Over
        </Button>
    )
}

export default StartOverButton
